import axios from 'axios';
import { useCallback, useEffect, useState } from 'react'
import {node_my_profile_should_show } from '../../../assets/jss/incept-sustainability-variables';


const useMyProfileHandler = () => {
  const [showMyProfile, setShowMyProfile] = useState(false);
  const token = localStorage.getItem('token');
  const authStr = 'Bearer ' + token;

  const fetchShouldShowMyProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${node_my_profile_should_show}`, {
      headers: {
        Authorization: authStr
      }
      });
      setShowMyProfile(response.data);
    } catch (error) {
      setShowMyProfile(false);
    }
   }, []);

   useEffect(() => {
    if (!token) return;
    fetchShouldShowMyProfile();
   }, [fetchShouldShowMyProfile, token]);

   return {showMyProfile};
}

export default useMyProfileHandler;